import { delay, put, takeEvery, call, select } from 'redux-saga/effects';
import {
  requestLoginSuccess,
  requestLoginFailure,
  requestLogoutFailure,
  requestLogoutSuccess,
  requestAuthenticationSuccess,
  throwError,
} from 'redux/actions/actions';
import {
  RequestLoginAction,
  RequestLogoutAction,
  RequestAuthenticationAction,
} from 'redux/actions/type';
import { REQUEST_AUTHENTICATION, REQUEST_LOGIN, REQUEST_LOGOUT } from 'redux/actions/types';
import { authAPI, getAPI, postAPI, loginAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import { Auth } from 'commons/constants/KeyFlowConstants';
import UserVO from 'commons/vo/UserVO';
import { navigate } from '@reach/router';
import { path } from 'commons/router/routerConfig';
import KeyFlowError from 'commons/framework/KeyFlowError';
import { AxiosResponse } from 'axios';
import StatisticsLogVO from 'commons/vo/param/StatisticsLogVO';
import { requestStatisticsLog } from 'redux/actions/statisticsLog/actions';

function* requestLoginSaga(action: RequestLoginAction) {
  try {
    const { userId, password } = action.payload;
    const params = {
      userId,
      password,
    };

    const response: AxiosResponse = yield call(loginAPI, API.USER_LOGIN, params);
    const keyFlowResponse = new KeyFlowResponse(response.data);
    const resultList = keyFlowResponse.getResult(UserVO);
    const result: UserVO = resultList[0] as UserVO;
    console.log(result);

    const accessToken = response.headers.access_token as string;

    yield put(requestLoginSuccess({ user: result }));
    const logParam = new StatisticsLogVO({
      data: [{ TASK_TYPE: 'LOGIN' }],
      user: userId,
    });

    // 로컬 스토리지에 저장 - 토큰, 유저 정보 (id, 이름)
    localStorage.setItem(Auth.ACCESS_TOKEN, accessToken);
    localStorage.setItem(Auth.USER_ID, result.userId);
    localStorage.setItem(Auth.USER_NAME, result.name);
    const authority = result.authorities.map(v => v.role).join(',');
    localStorage.setItem(Auth.AUTHORITIES, authority);

    yield navigate(path.SEARCH_BY_DATE);
    yield put(requestStatisticsLog({ param: logParam }));
  } catch (error: any | Error) {
    const { korMessage } = error as KeyFlowError;
    yield put(requestLoginFailure({ errorMessage: korMessage }));
  }
}

function* requestLogoutSaga(action: RequestLogoutAction) {
  try {
    const response: AxiosResponse = yield call(getAPI, API.USER_LOGOUT);

    // 로컬 스토리지에서 제거
    localStorage.removeItem(Auth.ACCESS_TOKEN);
    localStorage.removeItem(Auth.USER_ID);
    localStorage.removeItem(Auth.USER_NAME);

    const keyFlowResponse = new KeyFlowResponse(response.data);
    yield put(requestLogoutSuccess());
    yield navigate(path.LOGIN);
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestLogoutFailure());
  }
}

function* requestAuthenticationSaga(action: RequestAuthenticationAction) {
  try {
    const { url } = action.payload;
    yield put(requestAuthenticationSuccess());

    if (localStorage.getItem(Auth.ACCESS_TOKEN) == null) {
      yield navigate(path.LOGIN);
    } else if (url === path.HOME || url === path.LOGIN) {
      yield navigate(path.SEARCH_BY_DATE);
    } else {
      yield navigate(url);
    }
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestLogoutFailure());
    yield navigate(path.LOGIN);
  }
}

export function* watchUserSaga() {
  yield takeEvery(REQUEST_LOGIN, requestLoginSaga);
  yield takeEvery(REQUEST_LOGOUT, requestLogoutSaga);
  yield takeEvery(REQUEST_AUTHENTICATION, requestAuthenticationSaga);
}
